import { random, round2Str } from "../helpers/helpers";
import { aqiMeterRegistry } from "./aqiMeterRegistry";

const formatDateTime = (date) => {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    const hh = String(date.getHours()).padStart(2, "0");
    const mi = String(date.getMinutes()).padStart(2, "0");
    const ss = String(date.getSeconds()).padStart(2, "0");

    return `${yyyy}-${mm}-${dd} ${hh}:${mi}:${ss}`;
};

export const generateAqiIndoorLineDemo = ({
    meter_id,
    start,
    end,
}) => {
    const meter = aqiMeterRegistry.find(
        (m) => m.meter_id === Number(meter_id)
    );

    if (!meter) {
        return {
            chart_data: [],
            is_co: false,
            is_formaldehyde: false,
            is_humidity: false,
            is_pm10: false,
            is_pm2: false,
            is_temperature: false,
            is_tvoc: false,
        };
    }

    const { ranges } = meter;

    const startDate = new Date(`${start}T00:00:00`);
    const endDate = new Date(`${end}T23:59:59`);
    const now = new Date();

    // Prevent future data
    const effectiveEnd = endDate > now ? now : endDate;

    // Initial smooth base values
    let temp = random(ranges.temperature[0], ranges.temperature[1]);
    let hum = random(ranges.humidity[0], ranges.humidity[1]);
    let co = random(ranges.co[0], ranges.co[1]);
    let tvoc = random(ranges.tvoc[0], ranges.tvoc[1]);
    let formaldehyde = random(
        ranges.formaldehyde[0],
        ranges.formaldehyde[1]
    );
    let pm2 = random(ranges.pm2[0], ranges.pm2[1]);
    let pm10 = random(ranges.pm10[0], ranges.pm10[1]);

    const chart_data = [];
    let cursor = new Date(startDate);

    while (cursor <= effectiveEnd) {
        // Smooth drift
        temp += random(-0.2, 0.2);
        hum += random(-0.6, 0.6);
        co += random(-80, 80);
        pm2 += random(-5, 5);
        pm10 += random(-10, 10);

        // Clamp within allowed ranges
        temp = Math.min(Math.max(temp, ranges.temperature[0]), ranges.temperature[1]);
        hum = Math.min(Math.max(hum, ranges.humidity[0]), ranges.humidity[1]);
        co = Math.min(Math.max(co, ranges.co[0]), ranges.co[1]);
        pm2 = Math.min(Math.max(pm2, ranges.pm2[0]), ranges.pm2[1]);
        pm10 = Math.min(Math.max(pm10, ranges.pm10[0]), ranges.pm10[1]);

        chart_data.push({
            device_time: formatDateTime(cursor),
            temperature: round2Str(temp),
            humidity: round2Str(hum),
            co: round2Str(co),
            tvoc: round2Str(tvoc),
            formaldehyde: round2Str(formaldehyde),
            pm2: round2Str(pm2),
            pm10: round2Str(pm10),
        });

        // 15-minute interval
        cursor.setMinutes(cursor.getMinutes() + 15);
    }

    return {
        chart_data,
        is_co: true,
        is_formaldehyde: true,
        is_humidity: true,
        is_pm10: true,
        is_pm2: true,
        is_temperature: true,
        is_tvoc: true,
    };
};